var Vendd = (function (Vendd) {
	'use strict';

	Vendd.Helpers = (function (Helpers) {

		Helpers.textStrength = function (value) {
            var score = 0, variations, variationCount;

            if (!value)
                return 0;

            score += value.length * 5;

            variations = {
                digits: /\d/.test(value),
                lower: /[a-z]/.test(value),
                upper: /[A-Z]/.test(value),
                nonWords: /\W/.test(value),
            }

            variationCount = 0;
            for (var check in variations) {
                variationCount += (variations[check] == true) ? 1 : 0;
            }
            score += (variationCount - 1) * 10;

            if (score.toString() === 'NaN')
                score = 0;

            var transformScore = function (s) {
                var matched = 0;

                var StrengthVeryWeakValue = 5,
	                StrengthWeakValue = 28,
	                StrengthNormalValue = 43,
	                StrengthStrongValue = 68,
	                StrengthVeryStrongValue = 108;

                if (s >= StrengthVeryWeakValue && s < StrengthWeakValue) {
                    matched = 1;
                }
                else if (s >= StrengthWeakValue && s < StrengthNormalValue) {
                    matched = 2;
                }
                else if (s >= StrengthNormalValue && s < StrengthStrongValue) {
                    matched = 3;
                }
                else if (s >= StrengthStrongValue && s < StrengthVeryStrongValue) {
                    matched = 4;
                }
                else if (s >= StrengthVeryStrongValue) {
                    matched = 5;
                }

                return matched;
            }

            return transformScore(parseInt(score));
        };

        Helpers.IsHTML = function (string) {

            var a = document.createElement('div');
            a.innerHTML = string;

            for (var c = a.childNodes, i = c.length; i--;)
                if (c[i].nodeType === 1)
                    return true;

            return false;
        };

     
        Helpers.isInteger = function (x) {

            if (typeof x === 'number') {
                if (x % 1 === 0) {
                    return true;
                }
                return false;
            }
            return false;
            //return (typeof x === 'number') && (x % 1 === 0);
        };

        Helpers.ValidateNumbers = function (evt) { 
            var theEvent = evt || window.event;
            var key = theEvent.keyCode || theEvent.which;
            key = String.fromCharCode(key);
            var regex = /[0-9]|\./;
            if (!regex.test(key)) {
                theEvent.returnValue = false;
                if (theEvent.preventDefault) theEvent.preventDefault();
            }
        };

		return Helpers;

	})(Vendd.Helpers || {});

	return Vendd;

})(Vendd || {});